import type { ReactNode } from 'react'
import { ReviewCard } from '../review-card'
import { RequestItem } from './request-item'

interface RequestDataProps {
  name?: string
  ra?: string
  previousCourse?: string
  desiredCourse?: string
  createdAt?: string
  status?: string
  oldEducationLabel?: string
  desiredEducationLabel?: string
  workloadSummary?: ReactNode
  curriculoDeIngresso?: string
}

export const RequestData = ({
  createdAt,
  desiredCourse,
  name,
  previousCourse,
  ra,
  status,
  workloadSummary,
  desiredEducationLabel = 'Curso Desejado',
  oldEducationLabel = 'Curso Antigo',
  curriculoDeIngresso
}: RequestDataProps) => {
  function dateToText(dateString?: string) {
    if (dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString('pt-BR').split('T')[0]
    }

    return '--'
  }

  return (
    <ReviewCard title="Dados da Solicitação">
      <ul className="grid grid-cols-2 gap-3 px-6 py-3">
        <li>
          <RequestItem label="Nome Completo" value={name} />
        </li>
        <li className="flex gap-2">
          <RequestItem label="RA" value={ra} />
        </li>
        <li>
          <RequestItem label={oldEducationLabel} value={previousCourse} />
        </li>
        <li>
          <RequestItem label={desiredEducationLabel} value={desiredCourse} />
        </li>
        <li>
          <RequestItem label="Data de abertura" value={dateToText(createdAt)} />
        </li>
        <li>
          <RequestItem label="Status" value={status} />
        </li>
        {workloadSummary}
        <li>
          <RequestItem
            label="Currículo de Ingresso"
            value={curriculoDeIngresso}
          />
        </li>
      </ul>
    </ReviewCard>
  )
}
